<template>
  <header
    class="banner animated fadeIn"
    :class="modifiedClass"
    :style="{ backgroundImage: `url(${imgUrl})` }"
  >
    <div class="banner-content animated fadeIn">
      <slot />
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {
    imgUrl: String,
    flex: {
      type: Boolean,
      default: false
    },
    setBackdrop: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    modifiedClass() {
      let className = ''
      if ( this.flex)
        className += 'banner--flex'
      if ( this.setBackdrop )
        className += ' banner--backdrop'
      
      return className
    }
  }
};
</script>

<style lang="scss">
.banner {
  $root: &;

  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &::before {
    top: 0;
    right: 0;
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    background: linear-gradient(to left, #f4f4f8, #fff);
  }

  &-content {
    width: 100%;
    color: #fff;
    padding: 0 1rem;
    font-weight: 100;
    position: relative;
    text-shadow: 0 0 2px rgba(#000, 0.7);

    h1 {
      font-size: 2.5rem;
      margin-bottom: 2rem;
    }

    p {
      line-height: 1.7;
      font-size: 0.9rem;
      padding: 1rem;
      background: rgba(#000, 0.4);
    }
  }

  &--flex {
    #{$root}-content {
      margin-top: calc(89.5px + 2rem);
      display: flex;
      text-align: center;
      justify-content: center;
      flex-direction: column;
      padding: 0 1rem;
      justify-content: center;
      gap: 2rem;

      @media (min-width: 1024px) {
        margin-top: unset;
        text-align: unset;
        justify-content: space-between;
        flex-direction: row;
      }
    }
  }

  &--backdrop {
    &::before {
      background: rgba(#000, .4);
    }
  }
}

@media screen and (min-width: 1024px) {
  .banner {
    &-content {
      width: 100%;
      max-width: 1024px;
      margin: 6rem auto;

      h1 {
        font-size: 4rem;
        margin-bottom: 4rem;
      }

      p {
        width: 600px;
        font-size: 1.1rem;
      }
    }
  }

  .primary-btn {
    &::after {
      opacity: 0;
      content: "\f054";
      font-weight: 900;
      visibility: hidden;
      transition: 0.3s all;
      font-family: "Font Awesome 5 Free";
    }
    &:hover {
      &::after {
        opacity: 1;
        content: "\f054";
        font-weight: 900;
        margin-left: 1rem;
        visibility: visible;
        font-family: "Font Awesome 5 Free";
      }
    }
  }
}
</style>
